import React, { FC } from "react";
import { SEO } from "src/components/SEO/SEO";

const NotFound: FC = () => {
  return (
    <>
      <SEO
        title="Сторінку не знайдено"
        description="Запитана сторінка не існує"
        noindex
        nofollow
      />
      <div>NotFound</div>
    </>
  );
};

export default NotFound;
